import { Controller } from "@hotwired/stimulus"

// Reveals the free-text chain box only when "Other…" is picked, so the common
// case stays a single dropdown. The field keeps its name either way — the
// controller decides which of the two values to store.
export default class extends Controller {
  static targets = ["select", "field"]

  toggle() {
    const other = this.selectTarget.value === "other"
    this.fieldTarget.classList.toggle("hidden", !other)
    if (other) this.fieldTarget.querySelector("input")?.focus()
  }
}
